import JwtService from '@/core/services/jwt.service'

export default function verifyRoute({ from, next, store }) {

  let path = window.location.pathname
  if (!path.startsWith('/login') && !path.startsWith('/callback') && !path.startsWith('/404')) {
    JwtService.setCurrentRoute(window.location.href)
  }
  return next()
}